import { render, staticRenderFns } from "./McpPage.vue?vue&type=template&id=2399380d&scoped=true&"
import script from "./McpPage.vue?vue&type=script&lang=js&"
export * from "./McpPage.vue?vue&type=script&lang=js&"
import style0 from "./McpPage.vue?vue&type=style&index=0&id=2399380d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399380d",
  null
  
)

export default component.exports